export function trackerLinkedin(entity, path) {
  if (entity.linkedin_url) return entity.linkedin_url.replace(/^https?:\/\//i, '')

  return entity.linkedin_id
    ? `www.linkedin.com/${path}/${encodeURIComponent(entity.linkedin_id)}`
    : undefined
}
